import { Image } from '@react-pdf/renderer'
import { ReactElement } from 'react'

import { pdfStyles } from './utils/pdfStyles'

interface SalesReportPdfGraphImageProps {
  graphImageSrc?: string
}

export const SalesReportPdfGraphImage = ({ graphImageSrc }: SalesReportPdfGraphImageProps): ReactElement | null => {
  if (!graphImageSrc) {
    return null
  }

  return <Image src={graphImageSrc} style={pdfStyles.graphImage} />
}
